import {
  LOAD_CATEGORIES,
  SELECT_CATEGORY,
  SELECT_ONE_PRODUCT,
  CLEAR_ONE_PRODUCT,
  START,
  SUCCESS
} from "../constants";

const initialState = {
  categoriesList: [],
  productsList: [1,2,3],
  renderProductsList: [],
  isRenderingCategories: false,
  isRenderingProducts: false,
  loading: false,
  loaded: false,
  shopHashUrl: '',
  shopAddress: '',
  selectedProduct: '',
  selectedCategory: '',
  showPopupAddCart: false,
};

export default (state = initialState, action) => {
  const {type, payload, response} = action;

  switch (type) {
    case LOAD_CATEGORIES + START:
      return { ...state, loaded: false, loading: true, isRenderingProducts: false, shopAddress: '' };

    case LOAD_CATEGORIES + SUCCESS:
      return { ...state, categoriesList: [...response.categories], productsList: [...response.items], loaded: true, loading: false, shopHashUrl: payload.hashShop, isRenderingProducts: false, shopAddress: payload.shopAddress};

    case SELECT_CATEGORY:
      return { ...state, renderProductsList: payload.id === 'all' ? state.productsList : state.productsList.filter(el => el.category_id === +payload.id), isRenderingProducts: true};

    case SELECT_ONE_PRODUCT:
      const currentProduct = state.productsList.filter(el => el.id === +payload.id);
      return { ...state, selectedProduct: currentProduct, showPopupAddCart: true, selectedCategory: state.categoriesList.filter(el => el.id === currentProduct[0].category_id), };

    case CLEAR_ONE_PRODUCT:
      return { ...state, selectedProduct: [], showPopupAddCart: false, selectedCategory: [] };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/categories.js